<template>

    <v-spin :spinning="loadingFlag" tip="" size="large" class="page_box_right" style="min-height: 500px;">
        <span class="layui-breadcrumb" lay-separator=">" style="visibility: visible;">
            <a href="/">首页</a><span lay-separator="">&gt;</span>
            <a class="target-text" href="javascript:;" style="color: #f08326!important;">学习资讯</a>
        </span>

        <div id="fitslist" v-for="(item,index) in navList" :key="index" class="item-module-list" data-id="33"
            style="min-height: 400px">
            <div class="index_6_2_1_4">
                <div class="index_6_2_1_4_1"><img :src="item.contentPic" height="110" alt=""></div>
                <div class="index_6_2_1_4_2">
                    <p>来源：{{item.contentReource}} | 浏览：{{item.viewNum}} | 时间：{{item.insertTime}}</p>
                    <p></p>
                </div>
            </div>
        </div>


        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </v-spin>

    <!-- <div class="page_box_right">
       

    </div> -->
</template>
<script>

    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                loadingFlag: false,
                total: 0,//一共多少条
                pagesize: 5,  //一页几条
                currentPage: 1,//当前页
                navList: []
            }
        },
        created() {
            this.loadData(this.currentPage, this.pagesize);
        },
        mounted() {

        },
        methods: {
            //切换每页多少条 触发
            handleSizeChange(val) {
                this.pagesize = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            loadData(page, limit) {
                this.loadingFlag = true;
                let parames = new URLSearchParams();
                parames.append('navId', 33);
                parames.append('page', page);
                parames.append('limit', limit);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/navList', parames).then(resp => {

                    this.total = resp.data.count;

                    if (resp.data.code === 1) {

                        resp.data.data.forEach(element => {
                            element.contentPic = this.serverUrl + this.prefiexUrl + element.contentPic;
                        });

                        this.navList = resp.data.data;

                    }
                    this.loadingFlag = false;
                }).catch(err => {
                    console.log(err);
                })
            }
        }
    }
</script>

<style scoped>
    #fitslist .index_6_2_1_4_2 p {
        font-size: 14px;
        color: #777777;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
    }

    #fitslist .index_6_2_1_4_2 h2 {
        display: block;
        font-size: 16px;
        margin-bottom: 10px;
        color: #4E4E4E;
        text-align: left;
        padding: 0px;
        font-weight: bold;
    }

    #fitslist .index_6_2_1_4_2 {
        width: 980px;
        height: 110px;
        padding: 0 15px;
        float: left;
    }

    #fitslist .index_6_2_1_4 {
        width: 100%;
        height: 110px;
        padding-bottom: 25px;
        border-bottom: #eeeeee solid 1px;
        margin-top: 15px;
        float: left;
    }

    #fitslist {
        width: auto;
        margin: auto;
        min-height: 400px;
        height: auto;
        padding: 0 15px;
        border-radius: 8px;
    }

    .layui-breadcrumb {
        font-size: 0;
    }

    .page_box_right {
        width: 1200px;
        height: auto;
        overflow: hidden;
        margin: 0 auto;
        margin-top: 20px;
    }

    .layui-breadcrumb {
        display: block;
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/learningConsultation.vue